/**
 * Re-export shared dial + agent name contact from book-appointment.
 */
export {
  AppointmentSalesContact,
  type AppointmentSalesContactProps,
} from '@/modules/book-appointment/components/AppointmentSalesContact';
export { default } from '@/modules/book-appointment/components/AppointmentSalesContact';
